import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { FormatISODate, FormatISODateTime } from '../../../helpers/formatting'

export default function SettlementOfferForm(props) {
  const { control, responseData, actionDisabled } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval for settlement plan for customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link> for Loan <Link to={`payment_schedule/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.loan?.label}</b></Link>, Final payment date {FormatISODate(responseData?.payment_plan?.final_payment_date)}.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="divider m-0 my-2"></div>

      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Discount Percent:</label>
        <Controller
          name="discount_percent"
          control={control}
          defaultValue={responseData?.payment_plan?.discount_percent ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly min={responseData?.payment_plan?.discount_percent ?? 0} />
          )}
        />
      </div>

      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Duration:</label>
        <input type="text" className="input is-small lox-no-border" readOnly value={responseData?.payment_plan?.duration_days != null ? `${responseData.payment_plan.duration_days} days` : ''} />
      </div>
    </>
  )
}
